import {
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import { Search } from "@mui/icons-material";
import color from "../../components/utils/Colors";
import FeeCollectionCard from "../../components/cards/FeeCollectionCard";
import { useEffect, useState } from "react";
import { BillingStat, fetchBillingStats } from "../../services/adminData";

const AdminBillig = () => {
  const isSmallScreen = useMediaQuery("(max-width:1050px)");
  const [feeData, setFeeData] = useState<BillingStat[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchBillingStats()
      .then(setFeeData)
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        backgroundImage: "url('/images/logo 2.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "auto",
        margin: isSmallScreen ? "10px" : "30px",
        marginTop: "0px",
        paddingTop: "20px",
        gap: "3%",
        borderRadius: "10px",
        flexDirection: isSmallScreen ? "column" : "row",
      }}
    >
      <AdminSidebar />

      <Box sx={{ flex: 1, borderRadius: "16px" }}>
        <TextField
          className="input-root2"
          placeholder="Search..."
          size="small"
          InputProps={{
            startAdornment: (
              <IconButton>
                <Search />
              </IconButton>
            ),
          }}
          sx={{ width: { xs: "100%", md: "auto" } }}
        />

        <Box
          sx={{
            position: "relative",
            background: color.firstColor,
            borderRadius: "16px",
            height: "fit-content",
            my: 4,
          }}
        >
          <Box
            component="img"
            src="/assets/Welcome Bar.svg"
            alt="Welcome Bar"
            sx={{
              width: "100%",
              height: { xs: 150, sm: 200 },
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              top: { xs: "25%", sm: "20%" },
              left: "3%",
              fontSize: { xs: "56px", sm: "86px" },
              fontWeight: "bold",
            }}
          >
            Billing
          </Typography>
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              left: "3%",
              top: { xs: "70%", sm: "72%" },
              fontSize: { xs: "14px", sm: "18px" },
            }}
          >
            Revenue from successful course payments across the platform.
          </Typography>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress sx={{ color: color.firstColor }} />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              gap: 4,
              justifyContent: "space-around",
              flexWrap: "wrap",
              alignItems: { xs: "center", sm: "flex-start" },
            }}
          >
            {feeData.map((data) => (
              <FeeCollectionCard
                key={data.feetype}
                feetype={data.feetype}
                totalAmount={data.totalAmount}
                percentageIncrease={data.percentageIncrease}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminBillig;
